/* Nature's Melody embeddable chat widget (vanilla JS, no deps).
   Phase B: this same file drops into the Shopify theme via a <script> tag. */
(function () {
  const API = (window.NM_AGENT_API || "") + "/api/chat";

  const history = []; // [{role, content}]
  let streaming = false;

  // --- DOM ---
  const launcher = el("button", "nm-launcher", { title: "Chat" });
  launcher.textContent = "💬";

  const panel = el("div", "nm-panel");
  panel.innerHTML =
    '<div class="nm-header"><h3>Nature\'s Melody</h3>' +
    "<p>Ask about our chimes · wholesale welcome</p></div>" +
    '<div class="nm-log" id="nm-log"></div>' +
    '<form class="nm-inputbar" id="nm-form">' +
    '<input id="nm-input" autocomplete="off" placeholder="Message…" />' +
    '<button type="submit" id="nm-send">Send</button></form>';

  document.body.appendChild(launcher);
  document.body.appendChild(panel);

  const log = panel.querySelector("#nm-log");
  const form = panel.querySelector("#nm-form");
  const input = panel.querySelector("#nm-input");
  const sendBtn = panel.querySelector("#nm-send");

  launcher.addEventListener("click", () => {
    panel.classList.toggle("nm-open");
    if (panel.classList.contains("nm-open")) {
      if (log.childElementCount === 0) {
        addBot(
          "Hi! I can help you pick a wind chime by its sound or where you'll hang it — " +
            "and I look after wholesale enquiries too. 🙂",
        );
      }
      input.focus();
    }
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text || streaming) return;
    input.value = "";
    addUser(text);
    history.push({ role: "user", content: text });
    await send();
  });

  async function send() {
    streaming = true;
    sendBtn.disabled = true;
    const botEl = addBot("");
    let acc = "";

    try {
      const res = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history }),
      });
      if (!res.ok || !res.body) throw new Error("network");

      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";

      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        let sep;
        while ((sep = buf.indexOf("\n\n")) >= 0) {
          const line = buf.slice(0, sep).trim();
          buf = buf.slice(sep + 2);
          if (!line.startsWith("data:")) continue;
          const ev = JSON.parse(line.slice(5).trim());
          if (ev.type === "text") {
            acc += ev.text;
            botEl.textContent = acc;
            scroll();
          } else if (ev.type === "tool") {
            addChip(ev.label || "Working…");
          } else if (ev.type === "form") {
            renderForm(ev.form);
          } else if (ev.type === "error") {
            acc += (acc ? "\n\n" : "") + "Sorry, something went wrong. Please try again.";
            botEl.textContent = acc;
          }
        }
      }
    } catch {
      botEl.textContent = acc || "Sorry, I couldn't reach the server. Please try again.";
    } finally {
      renderLinks(botEl);
      if (acc) history.push({ role: "assistant", content: acc });
      streaming = false;
      sendBtn.disabled = false;
      input.focus();
    }
  }

  // --- helpers ---
  function el(tag, cls, attrs) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (const k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function addUser(t) {
    const n = el("div", "nm-msg nm-user");
    n.textContent = t;
    log.appendChild(n);
    scroll();
    return n;
  }
  function addBot(t) {
    const n = el("div", "nm-msg nm-bot");
    n.textContent = t;
    log.appendChild(n);
    scroll();
    return n;
  }
  function addChip(t) {
    const n = el("div", "nm-chip");
    n.textContent = t;
    log.appendChild(n);
    scroll();
  }
  // Option text for the language field is identical across every translation on purpose
  // (English/Español/中文 always read in their own language) — so a fixed map from that text
  // to a language code is safe here, no need to thread it through the i18n payload.
  var LANG_CODE_BY_LABEL = { English: "en", "Español": "es", "中文": "zh" };
  var FLAG_BY_LABEL = { English: "🇺🇸", "Español": "🇪🇸", "中文": "🇨🇳" };

  // Render the wholesale form; on submit, send its values back as one structured message.
  // If the form carries an i18n map (see WHOLESALE_FORM in tools.ts), picking a language re-labels
  // everything else on the spot — no server round trip. The language field itself is lifted out of
  // the normal field grid and shown as a compact flag dropdown in the top-right of the form card,
  // rather than as just another labelled row.
  function renderForm(form) {
    var wrap = el("div", "nm-form");
    var titleRow = el("div", "nm-form-titlerow");
    var title = el("div", "nm-form-title");
    titleRow.appendChild(title);
    wrap.appendChild(titleRow);

    var controls = {};
    var rows = {};
    for (var i = 0; i < form.fields.length; i++) {
      (function (f) {
        var isLangField = f.name === form.languageField;
        var row = el("label", isLangField ? "nm-form-lang" : "nm-form-row");
        var lab = el("span", "nm-form-label");
        if (!isLangField) row.appendChild(lab);
        var input;
        if (f.type === "select") {
          input = el("select");
        } else if (f.type === "textarea") {
          input = el("textarea");
          input.rows = 2;
        } else {
          input = el("input");
          input.type = f.type === "email" ? "email" : "text";
        }
        if (isLangField) input.setAttribute("aria-label", f.label);
        row.appendChild(input);
        controls[f.name] = { field: f, input };
        rows[f.name] = { row: row, label: lab, input: input };
        if (isLangField) {
          titleRow.appendChild(row);
        } else {
          wrap.appendChild(row);
        }
      })(form.fields[i]);
    }

    var btn = el("button", "nm-form-submit");
    btn.type = "button";
    wrap.appendChild(btn);

    // Fills in every piece of on-screen text (title, labels, placeholders, select options,
    // submit button) from one translation entry, keeping each field's current value where
    // the option/text is still valid. The language field's own select is special-cased: it
    // always shows flags (not the option label text) and its value tracks langCode directly,
    // rather than trying to preserve whatever was previously selected.
    function applyTranslation(t, langCode) {
      title.textContent = t.title;
      btn.textContent = t.submitLabel;
      for (var name in rows) {
        var tf = t.fields[name];
        if (!tf) continue;
        var field = controls[name].field;
        var input = rows[name].input;
        var isLangField = name === form.languageField;
        // Keep the label text set (even though it's not appended to the DOM for the language
        // field — see the field-creation loop above) so the submit summary below can still
        // read a proper "Language: Español" line from it.
        rows[name].label.textContent = tf.label + (field.required ? " *" : "");
        if (field.type === "select") {
          var prev = input.value;
          input.innerHTML = "";
          if (isLangField) {
            (tf.options || field.options || []).forEach(function (o) {
              var op = el("option");
              op.value = o;
              op.textContent = FLAG_BY_LABEL[o] || o;
              op.title = o;
              input.appendChild(op);
            });
            var ownLabel = Object.keys(LANG_CODE_BY_LABEL).filter(function (l) {
              return LANG_CODE_BY_LABEL[l] === langCode;
            })[0];
            if (ownLabel) input.value = ownLabel;
          } else {
            var blank = el("option");
            blank.value = "";
            blank.textContent = "—";
            input.appendChild(blank);
            (tf.options || field.options || []).forEach(function (o) {
              var op = el("option");
              op.value = o;
              op.textContent = o;
              input.appendChild(op);
            });
            if ([].slice.call(input.options).some(function (o) { return o.value === prev; })) {
              input.value = prev;
            }
          }
        } else if (tf.placeholder) {
          input.setAttribute("placeholder", tf.placeholder);
        }
      }
    }

    if (form.i18n) {
      applyTranslation(form.i18n.en || { title: form.title, submitLabel: form.submitLabel, fields: {} }, "en");
      var langField = form.languageField && rows[form.languageField];
      if (langField) {
        langField.input.addEventListener("change", function () {
          var code = LANG_CODE_BY_LABEL[langField.input.value];
          if (code && form.i18n[code]) applyTranslation(form.i18n[code], code);
        });
      }
    } else {
      // No i18n map — fall back to whatever labels/placeholder came from the server as-is.
      title.textContent = form.title;
      btn.textContent = form.submitLabel;
      for (var name2 in rows) {
        var f2 = controls[name2].field;
        rows[name2].label.textContent = f2.label + (f2.required ? " *" : "");
        if (f2.type === "select") {
          (f2.options || []).forEach(function (o) {
            var op = el("option");
            op.value = o;
            op.textContent = o;
            rows[name2].input.appendChild(op);
          });
        } else if (f2.placeholder) {
          rows[name2].input.setAttribute("placeholder", f2.placeholder);
        }
      }
    }

    log.appendChild(wrap);
    scroll();

    btn.addEventListener("click", () => {
      if (streaming) return;
      const values = {};
      for (const name in controls) {
        const { field, input } = controls[name];
        const v = (input.value || "").trim();
        input.style.borderColor = "";
        if (field.required && !v) {
          input.style.borderColor = "#c0392b";
          input.focus();
          return;
        }
        if (field.type === "email" && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
          input.style.borderColor = "#c0392b";
          input.focus();
          return;
        }
        if (v) values[name] = v;
      }
      // Use whatever label is currently on screen (not the base English one) so the summary
      // the person sees, and sends, matches the language they just filled the form in.
      const parts = form.fields
        .filter((f) => values[f.name])
        .map((f) => `${rows[f.name].label.textContent.replace(/ \*$/, "")}: ${values[f.name]}`);
      const msg = "[Wholesale form submitted] " + parts.join(" | ");
      wrap.querySelectorAll("input,select,textarea,button").forEach((n) => (n.disabled = true));
      btn.textContent = "✓ " + btn.textContent.replace(/^✓ /, "");
      addUser("📋 " + parts.join("  ·  "));
      history.push({ role: "user", content: msg });
      send();
    });
  }
  function scroll() {
    log.scrollTop = log.scrollHeight;
  }
  // Turn bare URLs into links once the message is complete.
  function renderLinks(node) {
    const text = node.textContent;
    if (!/https?:\/\//.test(text)) return;
    node.innerHTML = text.replace(
      /(https?:\/\/[^\s)]+)(\)?)/g,
      '<a href="$1" target="_blank" rel="noopener">$1</a>$2',
    );
  }
})();
